import { SET_PROJECT_TAB_VALUE } from './types';

export function setProjectTabValue(tabValue: number) {
  return {
    type: SET_PROJECT_TAB_VALUE,
    payload: tabValue,
  };
}
